<template>
	<div class="c-list-controls">
		<b-button-group>
			<!-- <b-button @click="onClick('comment')" variant="info" title="Add comment"
        ><message-square-icon
          size="1x"
        ></message-square-icon
      ></b-button> -->
			<b-button @click="onClick('open')" variant="info" title="Open detail view"
				><maximize-2-icon size="1x" class="custom-class"></maximize-2-icon
			></b-button>
			<b-button
				v-if="currentSelection"
				@click="onClick('smartcopy')"
				variant="primary"
				v-b-tooltip.hover
				:title="'Smart copy - Set to ' + currentSelection"
				><copy-icon size="1x"></copy-icon
			></b-button>
			<!-- <b-button
				variant="info"
				title="Comment"
				class="note-comment-trigger"
				:data-id="id"
				><message-circle-icon size="1x"></message-circle-icon
			></b-button> -->
			<b-button
				v-if="!disableCopy"
				@click="onClick('copy')"
				variant="info"
				title="Copy annotation"
				><copy-icon size="1x"></copy-icon
			></b-button>
			<!-- <b-button
				v-if="!disableCopy"
				@click="onClick('preview')"
				variant="info"
				title="Open preview"
				><book-open-icon size="1x"></book-open-icon
			></b-button> -->
			<b-button
				@click="onClick('external-link')"
				variant="info"
				title="Open external link"
				><external-link-icon size="1x"></external-link-icon
			></b-button>
		</b-button-group>
	</div>
</template>

<script>
import {
	MessageSquareIcon,
	ExternalLinkIcon,
	CopyIcon,
	Maximize2Icon,
	BookOpenIcon,
	MessageCircleIcon,
} from 'vue-feather-icons';
export default {
	components: {
		MessageSquareIcon,
		ExternalLinkIcon,
		CopyIcon,
		Maximize2Icon,
		BookOpenIcon,
		MessageCircleIcon,
	},
	props: ['disableCopy', 'id'],
	computed: {
		currentSelection: function () {
			return this.$store.getters['smartCopy/currentSelection'];
		},
	},
	methods: {
		onClick: function (action) {
			if (action === 'smartcopy') {
				this.$store.dispatch(
					'message/onSmartCopy',
					`Highlight copied as ${this.currentSelection}`
				);
			}
			this.$emit('clickHandler', action);
		},
	},
};
</script>

<style lang="scss">
.c-list-controls {
	position: absolute;
	top: 0;
	right: 0;
	//background-color: rgba(0, 0, 0, 0.75);
	//padding: var(--margin-lg) var(--margin-lg);
	border-radius: var(--spacer);
	.btn.btn-info,
	.btn.btn-primary {
		width: var(--spacer);
		height: var(--spacer);
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: var(--spacer) !important;
		background-color: var(--g3);

		&:not(:last-child) {
			margin-right: var(--margin-lg) !important;
		}

		&:hover,
		&:active {
			background-color: var(--g1) !important;
		}
	}

	.note-comment-trigger {
		svg {
			pointer-events: none;
		}
	}
}
</style>